<template>
    <div>
        <v-text-field label="企業コード"
                      v-bind:value="value"
                      v-on:input="(x) => $emit('input', x)"
                      @blur="onBlur"
                      @keydown.enter="onEnter"
                      clearable
                      maxlength="3"
                      :rules="rules"
                      :disabled="disabled" >
            <template v-slot:append>
                <span  class="mx-2 my-code-name" v-if="selected_item != null">{{selected_item.company_name}}</span>
                <v-btn icon color="primary darken-3" style="text-align:center;" small
                       v-on:click="onClick">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
            </template>
        </v-text-field>

        <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
                <v-card-title class="headline">企業一覧</v-card-title>
                <v-card-text>

                    <v-container>

                        <v-text-field label="企業名(あいまい)" v-model="search.company_name" clearable>

                        </v-text-field>

                        <v-row>
                            <v-col></v-col>
                            <v-col cols="auto">
                                <span>
                                    対象件数 {{ this.company_list.length }}件
                                </span>
                                <v-btn class="mx-2" color="primary darken-3" dark @click="onSearchCompany">検索</v-btn>
                                <v-btn class="mx-2" color="primary darken-3" dark @click="dialog = false">閉じる</v-btn>
                            </v-col>
                        </v-row>


                        <v-simple-table dense height="500px">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left"></th>
                                        <th class="text-left">企業コード</th>
                                        <th class="text-left">企業名</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in company_list" :key="i">
                                        <td>
                                            <v-btn class="mx-2" color="primary darken-3" dark v-on:click="onSelectRow(item)">選択</v-btn>
                                        </td>
                                        <td>{{ item.company_code }}</td>
                                        <td>{{ item.company_name }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Vue from 'vue'
    import MyAxios from './MyAxios.vue'
    Vue.mixin(MyAxios);

    export default {
        props: {
            value: {
                type: String,
                default: '',
            },
            rules: {
                type: Array,
                default: () => [],
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        watch: {
            value: function (val) {
                if (val !== this.selected_item.company_code) {
                    this.selected_item = null;
                }
            },
            'selected_item.company_name': function(val) {
                console.log(val);
                this.$emit('onChangeCompanyName', val);
            }
        },
        data: () => ({
            dialog: false,
            search: {
                company_name: "",
            },
            company_list: [],
            selected_item: null,
        }),
        methods: {
            onClick() {
                this.dialog = !this.dialog;
            },
            onSelectRow(item) {
                this.dialog = false;
                this.selected_item = item;
                this.$emit('input', item.company_code);
            },
            async onEnter(e) {
                if (e.keyCode !== 13) return;

                this.value = this.value.trim();
                await this.getCompany();
            },
            async onBlur() {
                this.value = this.value.trim();
                await this.getCompany();
            },
            async getCompany() {
                this.search.company_name = "";
                await this.onSearchCompany();

                for (var i in this.company_list) {
                    var item = this.company_list[i];
                    if (item.company_code == this.value) {
                        this.selected_item = item;
                        this.$emit('input', item.company_code);
                        break;
                    }
                }
            },
            async onSearchCompany() {
                try {
                    var params = new URLSearchParams();
                    params.append('param', JSON.stringify(this.search));

                    let res = await this.axios_post('/api/CommonComponents/CompanySearch', params);

                    if (res.data.status != "OK") {
                        this.msg_error_dialog(res.data.messages);
                        return;
                    }

                    this.company_list = res.data.company_list;

                } catch (err) {
                    this.msg_error_dialog(err);
                }
            }

        }

    }
</script>

<style>
    .my-code-name {
        padding: 6px 0 8px;
    }
</style>